customElements.get("product-form") ||
  customElements.define(
    "product-form",
    class extends HTMLElement {
      constructor() {
        super(),
          (this.form = this.querySelector("form")),
          (this.form.querySelector("[name=id]").disabled = !1),
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
          (this.cart =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer")),
          (this.submitButton = this.querySelector(
            '[id^="ProductSubmitButton-"]'
          )),
          (this.buyButton = this.querySelector('[id^="ProductBuyButton-"]')),
          this.buyButton &&
          (document.querySelector("cart-drawer") &&
            this.submitButton.setAttribute("aria-haspopup", "dialog"),
            (this.hideErrors = "true" === this.dataset.hideErrors)),
          this.setPersonalisedListeners(),
          this.setPhotoframeListener(),
          (this.goldChainAddOns = document.querySelectorAll('[id^="addons_"]')),
          this.goldChainAddOns.forEach((t) => {
            t.addEventListener("click", this.goldChainAddOnsHandler.bind(this));
          });
        this.viewDetailsBtns = document.querySelectorAll(
          '[id^="buy-view-details-"]'
        );
        if (this.viewDetailsBtns.length > 0) {
          this.viewDetailsBtns.forEach((t) => {
            t.addEventListener("click", () => {
              let index = t.id.split("-")[3];
              document.getElementsByClassName(
                `buy-row-2-${index}`
              )[0].style.display = "none";
              document.getElementsByClassName(
                `buy-row-3-${index}`
              )[0].style.display = "flex";
            });
          });
        }
        this.hideDetailsBtns = document.querySelectorAll(
          '[id^="buy-hide-details-"]'
        );
        if (this.hideDetailsBtns.length > 0) {
          this.hideDetailsBtns.forEach((t) => {
            t.addEventListener("click", () => {
              let index = t.id.split("-")[3];
              document.getElementsByClassName(
                `buy-row-3-${index}`
              )[0].style.display = "none";
              document.getElementsByClassName(
                `buy-row-2-${index}`
              )[0].style.display = "flex";
            });
          });
        }
      }
      setPhotoframeListener() {
        const t = document.querySelectorAll(".photoFrameImg");
        t.length > 0 &&
          t.forEach((t) => {
            t.onchange = () => {
              const e = t.parentElement,
                s = e.querySelector(".photo"),
                r = e.querySelector(".frame"),
                i = t.files[0],
                o = new Image();
              (o.onload = () => {
                o.width > o.height
                  ? (s.classList.remove("photo-portrait"),
                    s.classList.add("photo-landscape"),
                    r.classList.remove("frame-cover-portrait"),
                    r.classList.add("frame-cover-landscape"))
                  : (s.classList.add("photo-portrait"),
                    s.classList.remove("photo-landscape"),
                    r.classList.remove("frame-cover-landscape"),
                    r.classList.add("frame-cover-portrait"));
              }),
                (o.src = URL.createObjectURL(i)),
                (e.querySelector("#uploadedPf").src = o.src),
                e
                  .querySelectorAll(".noPreviewPf")
                  .forEach((t) => (t.style.display = "none")),
                e
                  .querySelectorAll(".previewPf")
                  .forEach((t) => (t.style.display = "block"));
            };
          });
      }
      setPersonalisedListeners() {
        const t = (e, s) => {
          const r = window.innerWidth < 740 ? 13 : 35,
            i = document.querySelector("div#outer"),
            o = document.querySelector("div#outer div");
          s && (o.style.fontSize = "100px");
          const a = window
            .getComputedStyle(o, null)
            .getPropertyValue("font-size");
          (o.style.fontSize = parseFloat(a) - 0.3 + "px"),
            o.clientHeight >= i.clientHeight + (window.innerWidth / r) * e &&
            t(e, !1),
            o.clientWidth >= i.clientWidth + (window.innerWidth / r) * e &&
            t(e, !1);
        };
        (this.letterInputs = this.querySelectorAll(".personalised-input")),
          this.letterInputs.forEach((e, s) => {
            const r = e.querySelector("input"),
              i = e.querySelector("#leftchars"),
              o = e.dataset.max,
              a = e.dataset.caps,
              n = "letters" + (s > 0 ? s + 1 : ""),
              d = document.getElementById(n),
              c = "allowSpace" in e.dataset && "true" === e.dataset.allowSpace,
              l = "resize" in e.dataset && "true" === e.dataset.resize,
              u = "hindi" in e.dataset && "true" === e.dataset.hindi;
            let h;
            r.addEventListener("input", async (s) => {
              if (
                s.target.getAttribute("maxlength") == 1 ||
                s.target.dataset.allCaps
              ) {
                s.target.value = s.target.value.toUpperCase();
              } else if (
                s.target.dataset.firstCap
              ) {
                s.target.value = s.target.value[0].toUpperCase() + s.target.value.slice(1);
              }
              let r = s.target.value;
              r.length > o && (r = r.slice(0, o));
              let n = 0,
                m = "";
              for (const t of r) {
                if (s.target.dataset.aphanumeric == "true") {
                  m += t;
                } else {
                  t >= "A" && t <= "Z" && n < a && ((m += t), n++),
                    t >= "a" && t <= "z" && (m += t),
                    t >= 0 && t <= 9 && (m += t),
                    " " === t && c && (m += t);
                }
              }
              (s.target.value = m),
                i &&
                ((i.innerHTML = `${o - m.length}/${o}`),
                  (i.style.color = o === m.length ? "red" : "#7D7D7D")),
                d &&
                (u
                  ? (clearTimeout(h),
                    (h = setTimeout(async () => {
                      if (m.length > 0) {
                        const t = await fetch(
                          `https://prod.giva-api.com/getHindi?text=${m.toUpperCase()}%20`
                        ),
                          e = await t.json();
                        d.innerHTML = e.data;
                      } else d.innerHTML = m;
                    }, 500)))
                  : (d.innerHTML = m)),
                l &&
                t(
                  e.dataset.divider && "true" === e.dataset.divider ? 1 : 0,
                  !0
                );
            });
          });
      }
      async onSubmitHandler(t) {
        const e = !!t.submitter.id.startsWith("ProductBuyButton-");
        if (
          this.submitButton &&
          (t && "function" == typeof t.preventDefault && t.preventDefault(),
            "true" === this.submitButton.getAttribute("aria-disabled"))
        )
          return;
        const i = new FormData(this.form);
        this.pairWithInput = document.querySelectorAll('[id^="pair_it_with_"]');
        let toBeAddedItems = [];
        if (window.location.href.includes("/products/") && isPairBtnClicked) {
          document
            .querySelector("#pair-button")
            .querySelector(".loading-overlay__spinner")
            .classList.remove("hidden");
          document
            .querySelector("#pair-button")
            .querySelector("#pair-button-text")
            .classList.add("pair-text-hidden");
          let cartItems = [];
          await fetch(routes.cart_url, fetchConfig())
            .then((t) => t.text())
            .then((t) => {
              cartItems = JSON.parse(t).items;
            });
          this.pairWithInput.forEach((t) => {
            if (t.type === "checkbox" && t.checked) {
              const pairId = t.id.split("pair_it_with_")[1];
              const pairVal = document.getElementById(
                `pair_it_with_input_${pairId}`
              ).value;
              if (
                cartItems.length === 0 ||
                (cartItems.length > 0 &&
                  cartItems.filter((item) => item.id == pairVal).length === 0)
              ) {
                toBeAddedItems.push(pairVal);
              }
            }
          });
          if (
            cartItems.length > 0 &&
            cartItems.filter((item) => item.id == i.get("id")).length > 0
          ) {
            i.delete("id");
            if (toBeAddedItems.length > 0) {
              i.append("id", toBeAddedItems[0]);
              toBeAddedItems.shift();
            } else {
              return;
            }
          }
        }
        this.handleErrorMessage(),
          this.submitButton &&
          (this.submitButton.setAttribute("aria-disabled", !0),
            e || this.submitButton.classList.add("loading")),
          this.buyButton &&
          (this.buyButton.setAttribute("aria-disabled", !0),
            e && this.buyButton.classList.add("loading"));
        const s = e
          ? this.buyButton
            ? this.buyButton.querySelector(".loading-overlay__spinner")
            : null
          : this.submitButton.querySelector(".loading-overlay__spinner");
        s && s.classList.remove("hidden");
        const r = fetchConfig("javascript");
        (r.headers["X-Requested-With"] = "XMLHttpRequest"),
          delete r.headers["Content-Type"];
        this.cart &&
          (i.append(
            "sections",
            this.cart.getSectionsToRender().map((t) => t.id)
          ),
            i.append("sections_url", window.location.pathname),
            this.cart.setActiveElement(document.activeElement));
        if (
          i.has("properties[_giftWrap]") &&
          "yes" === i.get("properties[_giftWrap]")
        ) {
          i.append("properties[_giftWrapWidget]", "pdp-gift_wrap");
        }
        r.body = i;
        const o =
          i.has("properties[_giftWrap]") &&
          "yes" === i.get("properties[_giftWrap]"),
          a = Array.from(this.goldChainAddOns).filter((t) => t.checked)[0];
        let n = false;
        Array.from(document.getElementsByClassName("box_addons")).forEach(
          (t) => {
            if (t.checked) {
              n = true;
            }
          }
        );
        e,
          fetch("" + routes.cart_add_url, r)
            .then((t) => t.json())
            .then(async (t) => {
              const s = [],
                r = { ...t };
              if ((o && s.push({ id: 31471233106010, quantity: 1 }), a)) {
                const t = document.getElementById("productId-" + a.id).value;
                s.push({ id: t, quantity: 1 });
              }
              if (n) {
                Array.from(
                  document.getElementsByClassName("box_addons")
                ).forEach((t) => {
                  if (t.checked) {
                    const e = t.previousElementSibling.value;
                    s.push({ id: e, quantity: 1 });
                  }
                });
              }
              if (
                window.location.href.includes("/products/") &&
                isPairBtnClicked
              ) {
                toBeAddedItems.forEach((t) => {
                  s.push({
                    id: t,
                    quantity: 1,
                    properties: { _widget: "pdp-pair_it_with" },
                  });
                });
              }
              if (
                (s.length > 0 &&
                  ((t = await fetch(routes.cart_add_url + ".js", {
                    method: "POST",
                    body: JSON.stringify({
                      items: s,
                      sections: "cart-icon-bubble,cart-notification-button",
                    }),
                    headers: { "Content-Type": "application/json" },
                  }).then((t) => t.json())),
                    (r.sections["cart-icon-bubble"] =
                      t.sections["cart-icon-bubble"]),
                    (r.sections["cart-notification-button"] =
                      t.sections["cart-notification-button"])),
                  t.status)
              ) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: "product-form",
                  productVariantId: i.get("id"),
                  errors: t.errors || t.description,
                  message: t.message,
                }),
                  this.handleErrorMessage(t.description);
                const e = this.submitButton.querySelector(".sold-out-message");
                if (!e) return;
                return (
                  this.submitButton.setAttribute("aria-disabled", !0),
                  this.submitButton
                    .querySelector("span")
                    .classList.add("hidden"),
                  e.classList.remove("hidden"),
                  void (this.error = !0)
                );
              }
              if (!this.cart)
                return void (window.location = window.routes.cart_url);
              if (e)
                if (window.openRzpLogin) {
                  window.openRzpLogin(),
                    this.submitButton.classList.remove("loading"),
                    this.buyButton &&
                    this.buyButton.classList.remove("loading"),
                    this.cart &&
                    this.cart.classList.contains("is-empty") &&
                    this.cart.classList.remove("is-empty"),
                    this.submitButton.removeAttribute("aria-disabled"),
                    this.buyButton &&
                    this.buyButton.removeAttribute("aria-disabled");
                  const t =
                    this.buyButton &&
                    this.buyButton.querySelector(".loading-overlay__spinner");
                  t && t.classList.add("hidden");
                } else window.location = "/checkout";
              this.error ||
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: i.get("id"),
                  cartData: t,
                }),
                (this.error = !1);
              const d = this.closest("quick-add-modal");
              d
                ? (document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(t);
                    });
                  },
                  { once: !0 }
                ),
                  d.hide(!0))
                : e ||
                window.location.pathname === window.routes.cart_url ||
                this.cart.renderContents(r),
                (this.submitButton.innerHTML = "Added to Cart");
              if (
                window.location.href.includes("/products/") &&
                isPairBtnClicked
              ) {
                isPairBtnClicked = false;
                document.getElementById("pair-button-text").innerHTML =
                  "Added to Cart";
              }
            })
            .catch((t) => {
              console.error(t);
            })
            .finally(async () => {
              e ||
                (this.submitButton.classList.remove("loading"),
                  this.buyButton && this.buyButton.classList.remove("loading")),
                this.cart &&
                this.cart.classList.contains("is-empty") &&
                this.cart.classList.remove("is-empty"),
                this.error ||
                e ||
                (this.submitButton.removeAttribute("aria-disabled"),
                  this.buyButton &&
                  this.buyButton.removeAttribute("aria-disabled")),
                !e && s && s.classList.add("hidden");
              if (t.submitter.classList.contains("wishlist-quick-add")) {
                document
                  .getElementById("cart-notification-overlay")
                  .classList.remove("active");
                const wishViewList =
                  document.getElementsByTagName("wish-view-list")[0];
                wishViewList.deleteWishItem(t.submitter.dataset.handle);
                document.getElementById("moved-to-cart").style.display = "flex";
                setTimeout(function () {
                  document.getElementById("moved-to-cart").style.display =
                    "none";
                }, 5000);
              }
              if (document.querySelector("#pair-button")) {
                document
                  .querySelector("#pair-button")
                  .querySelector(".loading-overlay__spinner")
                  .classList.add("hidden");
                document
                  .querySelector("#pair-button")
                  .querySelector("#pair-button-text")
                  .classList.remove("pair-text-hidden");
              }
            });
      }
      handleErrorMessage(t = !1) {
        this.hideErrors ||
          ((this.errorMessageWrapper =
            this.errorMessageWrapper ||
            this.querySelector(".product-form__error-message-wrapper")),
            this.errorMessageWrapper &&
            ((this.errorMessage =
              this.errorMessage ||
              this.errorMessageWrapper.querySelector(
                ".product-form__error-message"
              )),
              this.errorMessageWrapper.toggleAttribute("hidden", !t),
              t && (this.errorMessage.textContent = t)));
      }
      goldChainAddOnsHandler(t) {
        let e = t.target;
        this.goldChainAddOns.forEach((s) => {
          s.checked &&
            s !== t.target &&
            ((t.target.checked = !1),
              (document.querySelector(".addon_error_box").style.display = "flex"),
              setTimeout(() => {
                document.querySelector(".addon_error_box").style.display = "none";
              }, 3e3),
              (e = s));
        });
      }
    }
  );
